import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
	// Redirection
	{
		path: "/",
		redirect: { name: 'login' },
		meta: {
			publicPage: true,
		},
	},

	// Login
	{
      path: "/login",
      name: "login",
      component: () => import("@/components/auth/Login.component.vue"),
      meta: { publicPage: true },
    },
    {
      path: "/:association/login",
      name: "custom-login",
      component: () => import("@/components/auth/Login.component.vue"),
      meta: { publicPage: true },
    },
    // /cert-login (arriba, antes de rutas dinámicas)
    {
      path: '/cert-login',
      name: 'certlogin',
      component: () => import('@/components/auth/CertLogin.component.vue'),
      meta: { publicPage: true },
      beforeEnter: (to, from, next) => {
        console.info('[ROUTER] HIT /cert-login -> certlogin component');
        next();
      }
    },
	{
      path: '/:association/cert-login',
      name: 'custom-certlogin',
      component: () => import('@/components/auth/CertLogin.component.vue'), // unifica .vue
      meta: { publicPage: true },
    },
	// General info
	{
		path: "/general/:id",
		name: "general",
		component: () => import("../components/GeneralInformation.component"),
		meta: {
			publicPage: false,
		},
	},
	{
		path: "/:association/general/:id",
		name: "custom-general",
		component: () => import("../components/GeneralInformation.component"),
		meta: {
			publicPage: false,
		},
	},


	// Attachments
	{
		path: "/attachments/:id",
		name: "attachments",
		component: () => import("../components/Attachments.component"),
		meta: {
			publicPage: false,
		},
	},
	{
		path: "/:association/attachments/:id",
		name: "custom-attachments",
		component: () => import("../components/Attachments.component"),
		meta: {
			publicPage: false,
		},
	},


	// Forms Questions
	{
		path: "/forms/:id",
		name: "forms",
		component: () => import("../components/FormQuestions.component"),
		meta: {
			publicPage: false,
		},
	},
	{
		path: "/:association/forms/:id",
		name: "custom-forms",
		component: () => import("../components/FormQuestions.component"),
		meta: {
			publicPage: false,
		},
	},

	// PDF viewer
	{
		path: "/pdf-viewer",
		name: "pdf-viewer",
		component: () => import("../components/PdfView.component"),
		meta: {
			publicPage: false,
		},
	},
	{
		path: "/:association/pdf-viewer",
		name: "custom-pdf-viewer",
		component: () => import("../components/PdfView.component"),
		meta: {
			publicPage: false,
		},
	},

	// My Signatures
	{
		path: "/my-signatures",
		name: "my-signatures",
		component: () => import("../components/MySignatures.component.vue"),
		meta: {
			publicPage: false,
		}
	},
	{
		path: "/:association/my-signatures",
		name: "custom-my-signatures",
		component: () => import("../components/MySignatures.component.vue"),
		meta: {
			publicPage: false,
		}
	},

	// Previous Information
	{
		path: "/document-list",
		name: "document-list",
		component: () => import("../components/multiple/PreviousInformation.component.vue"),
		meta: {
			publicPage: false,
		}
	},
	{
		path: "/:association/document-list",
		name: "custom-document-list",
		component: () => import("../components/multiple/PreviousInformation.component.vue"),
		meta: {
			publicPage: false,
		}
	},

// Fields
{
  path: "/fields/:id",
  name: "fields",
  component: () => import("../components/FieldsSignature.component.vue"),
  meta: { publicPage: false }
},


	// Document list review
	{
		path: "/multiple-document-list-review",
		name: "multiple-document-list-review",
		component: () => import("../components/multiple/DocumentListReview.component"),
		meta: {
			publicPage: false,
		},
	},
	{
		path: "/:association/multiple-document-list-review",
		name: "custom-multiple-document-list-review",
		component: () => import("../components/multiple/DocumentListReview.component"),
		meta: {
			publicPage: false,
		},
	},

	// Summary
	{
		path: "/summary",
		name: "summary",
		component: () => import("../components/Summary.component"),
		meta: {
			publicPage: false,
		},
	},
	{
		path: "/:association/summary",
		name: "custom-summary",
		component: () => import("../components/Summary.component"),
		meta: {
			publicPage: false,
		},
	},
	/* Eliminamos componentes duplicados
	{
		path: "/summary",
		name: "single-doc-summary",
		component: () => import("../components/SingleDocumentSummary.component"),
		meta: {
			publicPage: false,
		},
	},
	{
		path: "/:association/summary",
		name: "custom-single-doc-summary",
		component: () => import("../components/SingleDocumentSummary.component"),
		meta: {
			publicPage: false,
		},
	},*/

	// Reject
	{
		path: "/rejected",
		name: "rejected",
		component: () => import("../components/Rejected.component"),
		meta: {
			publicPage: false,
		},
	},
	{
		path: "/:association/rejected",
		name: "custom-rejected",
		component: () => import("../components/Rejected.component"),
		meta: {
			publicPage: false,
		},
	},

	// Single document view
	{
		path: "/document/:id",
		name: "show-document",
		component: () => import("../components/PdfView.component"),
		meta: {
			publicPage: false,
		},
	},
	{
		path: "/:association/document/:id",
		name: "custom-show-document",
		component: () => import("../components/PdfView.component"),
		meta: {
			publicPage: false,
		},
	},

	// Multiple Attachments
	{
		path: "/multiple-attachments/:id",
		name: "multiple-attachments",
		component: () => import("../components/multiple/Attachments.component"),
		meta: {
			publicPage: false,
		},
	},
	{
		path: "/:association/multiple-attachments/:id",
		name: "custom-multiple-attachments",
		component: () => import("../components/multiple/Attachments.component"),
		meta: {
			publicPage: false,
		},
	},

	// Multiple Forms
	{
		path: "/multiple-forms/:id",
		name: "multiple-forms",
		component: () => import("../components/multiple/Forms.component"),
		meta: {
			publicPage: false,
		},
	},
	{
		path: "/:association/multiple-forms/:id",
		name: "custom-multiple-forms",
		component: () => import("../components/multiple/Forms.component"),
		meta: {
			publicPage: false,
		},
	},


	// Multiple Pdf
	{
		path: "/multiple-pdf",
		name: "multiple-pdf",
		component: () => import("../components/DocumentList.component"),
		meta: {
			publicPage: false,
		},
	},
	{
		path: "/:association/multiple-pdf",
		name: "custom-multiple-pdf",
		component: () => import("../components/DocumentList.component"),
		meta: {
			publicPage: false,
		},
	},


	// Multiple Request document view
	{
		path: "/multiple-document/:id",
		name: "multiple-show-document",
		component: () => import("../components/multiple/SingleDocumentView.component"),
		meta: {
			publicPage: false,
		},
	},
	{
		path: "/:association/document/:id",
		name: "custom-multiple-show-document",
		component: () => import("../components/multiple/SingleDocumentView.component"),
		meta: {
			publicPage: false,
		},
	},

    // ÚLTIMA: catch-all de asociación con redirect dinámico y log SIEMPRE
    {
      path: '/:association',
      meta: { publicPage: true },
      redirect: to => {
        const slug = (to.params.association || '').toLowerCase();
        console.warn('[ROUTER] HIT /:association, slug =', slug);

        if (slug === 'cert-login') {
          console.warn('[ROUTER] redirect → { name: "certlogin" }');
          return { name: 'certlogin' };
        }
        console.warn('[ROUTER] redirect → { name: "custom-login", association:', slug, ' }');
        return { name: 'custom-login', params: { association: slug } };
      },
    }


];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

// AFTER EACH: confirma qué ruta quedó finalmente
router.afterEach((to, from) => {
  const trace = (new URLSearchParams(location.search)).get('trace') === '1'
    || localStorage.getItem('DEBUG_ROUTES') === '1';
  if (!trace) return;
  console.log('[TRACE][afterEach]', from?.fullPath || '(init)', '->', to.fullPath, 'name:', to.name);
});



// Guard global: las públicas SIEMPRE pasan
router.beforeEach((to, from, next) => {
	const isLoggedIn = localStorage.getItem("auth_user_token");
	const association = to.params.association;

    // 🛠️ DEBUG: Mostrar datos en consola
    console.log("Navegando a:", to.name);
    console.log("Autenticado:", isLoggedIn ? "Sí" : "No");
    console.log("Asociación:", association || "No definida");
    localStorage.setItem("currentAssociation", association);

	// ⚠️ Evita redirecciones infinitas si ya estás en la página correcta
    if ((to.name === "login" || to.name === "custom-login") && !isLoggedIn) {
       return next(); // Permite continuar sin volver a redirigir
    }

	if (to.meta.publicPage && !isLoggedIn) {
		console.log('public page');
			// Check if association parameter is available and route accordingly
			if (association) {
					next({ name: 'custom-login', params: { association } });
			} else {
					next({ name: 'login' });
			}
	} else {
			next();
	}
});




export default router;
